import { ChunkedParams } from "../units/types/ChunkedParams"

export const createChunkedParams = (req?: Partial<ChunkedParams>): ChunkedParams => {
  return {
    ...req,
    pageSize: req?.pageSize ?? 10,
    pageIndex: req?.pageIndex ?? 1,
  }
}
